import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import DialogActions from "@material-ui/core/DialogActions";
import MuiDialogContent from "@material-ui/core/DialogContent";
import Dialog from "src/components/Dialog";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";

import { getEBayOAuthUrl } from "src/apiService/modules/ebay";
import { StatefulLoadableButton } from "src/components/LoadableButton";

import {
  useCanAddMoreEBayIntegrations,
  WantToAddAdditionalEBayStoresContent,
} from "../AddNewIntegrationDialog";
import DialogTitle from "../DialogTitle";
import type Step from "../Step";

interface EBayAdditionalStoresProps {
  onClose: () => void;
  onStepChange: (step: Step) => void;
}

type Options = "yes" | "no";

const useStyles = makeStyles((theme) => ({
  content: {
    margin: "auto",
  },
  radioGroup: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(4),
  },
}));

function WantToAddAdditionalEBayStoresDialog({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <WantToAddAdditionalEBayStoresContent onClose={onClose} />
    </Dialog>
  );
}

function EBayAdditionalStores({
  onClose,
  onStepChange,
}: EBayAdditionalStoresProps) {
  const classes = useStyles();
  const [value, setValue] = useState<Options>();
  const [open, setOpen] = useState(false);
  const canAddIntegrations = useCanAddMoreEBayIntegrations();

  const handleNext = async () => {
    if (value === "no") {
      onStepChange("poshmark:do-you-sell-on-poshmark");
      return;
    }

    if (!canAddIntegrations) {
      setOpen(true);
      return;
    }

    // Directly trigger eBay OAuth
    // Note: Errors are handled by StatefulLoadableButton's built-in try/catch
    const {
      data: { url },
    } = await getEBayOAuthUrl({
      integrationName: "eBay",
      back: "/get-started#ebay:import",
    });
    window.location = url;
  };

  return (
    <>
      <WantToAddAdditionalEBayStoresDialog
        open={open && !canAddIntegrations}
        onClose={() => setOpen(false)}
      />
      <DialogTitle onClose={onClose}>Set Up Questions - 2/9</DialogTitle>
      <MuiDialogContent className={classes.content}>
        <FormControl component="fieldset">
          <FormLabel component="legend">
            Do you have additional stores on eBay to integrate?
          </FormLabel>
          <RadioGroup
            value={value || null}
            onChange={(event) => {
              setValue((event.target as HTMLInputElement).value as Options);
            }}
            className={classes.radioGroup}
          >
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
          </RadioGroup>
        </FormControl>
      </MuiDialogContent>
      <DialogActions>
        <StatefulLoadableButton
          variant="contained"
          disabled={!value}
          onClick={handleNext}
          color="primary"
          autoFocus
        >
          Next
        </StatefulLoadableButton>
      </DialogActions>
    </>
  );
}

export default EBayAdditionalStores;
